<template lang="pug">
.iEditTips
  Button.btn(type='text',@click='event();editTips()') {{tipBtnType}}提示
</template>

<script>
export default {
  props: {
    isEdit: {
      type: Boolean,
      required: true
    },
    event: {
      type: Function,
      required: true
    }
  },
  data() {
    return {
      tipBtnType: "编辑"
    };
  },
  methods: {
    editTips() {
      // 编辑提示
      if (this.isEdit) {
        this.tipBtnType = "编辑";
      } else {
        this.tipBtnType = "删除";
      }
    }
  }
};
</script>

<style lang="stylus">
.btn
  color #3A76D2
</style>
